import React, { useRef, useState, useEffect } from 'react'
import { Button, Text, Input, Slider, MediaDialog, TagPreview } from 'ui';
import { baseTpl } from 'config/tags';
import "./index.css";
import { darkBlue } from 'config/colors';
import { Hue, Saturation, EditableInput } from 'react-color/lib/components/common';
import { CustomPicker } from 'react-color';

const MAX_FONTSIZE = 300;



class ColorPickerComponent extends React.Component {
  render() {
    return (
      <div>
        <div style={{position:'relative', height:80, marginBottom:10}}>
          <Saturation
            {...this.props}
          />
        </div>
        <div style={{position:'relative', height:12, marginBottom:12}}>
          <Hue
            {...this.props}
            // pointer={}
            direction="horizontal"
          />
        </div>
        <div style={{display:'flex', alignItems:'center'}}>
          <Text small block style={{marginRight:4}}>R</Text>
          <EditableInput
            style={{input:{width:24, padding:8, border:"1px solid #aaa", fontSize:12, marginRight:8}}}
            value={ this.props.rgb.r }
            {...this.props}
          />
          <Text small block style={{marginRight:4}}>G</Text>
          <EditableInput
            style={{input:{width:24, padding:8, border:"1px solid #aaa", fontSize:12, marginRight:8}}}
            value={ this.props.rgb.g }
            {...this.props}
          />
          <Text small block style={{marginRight:4}}>B</Text>
          <EditableInput
            style={{input:{width:24, padding:8, border:"1px solid #aaa", fontSize:12}}}
            value={ this.props.rgb.b }
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

const ColorPicker = CustomPicker(ColorPickerComponent);


export default function TagEditor({
  tag,
  media,
  onSave,
  onChangeType,
}) {
  
  
  
  // Hold tpl and html in state.
  // When the tag changes, use tag code.
  // When the HTML changes, update the frame.
  
  let [tpl, setTpl] = useState(null);
  const updateTpl = update => {
    setTpl({...baseTpl, ...tpl, ...update});
  };
  
  useEffect(() => {
    if(!tag) {
      return;
    }
    if(tag.tpl) {
      setTpl(tag.tpl);
    }
  }, [tag]);
  
  
  // Media Dialog
  
  const [isBGDialogOpen, setBGDialogOpen] = useState(false);
  const [isLogoDialogOpen, setLogoDialogOpen] = useState(false);
  
  
  
  // Background
  
  const bgUploaderRef = useRef();
  const [bgColor, setBgColor] = useState(tpl && tpl.background && tpl.background.indexOf("#") === 0 ? {hex:tpl.background} : {hex:"#ffffff"});
  const [bgFile, setBgFile] = useState(null);
  const [bgUploading, setBgUploading] = useState(false);
  
  async function handleBgUploaderChange(e) {
    if(bgUploading) {
      return;
    }
    setBgUploading(true);
    try {
      setBgFile(e.target.files[0]);
      var fr = new FileReader();
      fr.onload = function () {
        updateTpl({background:`url(${fr.result})`});
      };
      fr.readAsDataURL(e.target.files[0]);
    } catch(error) {
      console.error(error);
      setBgUploading(false);
      return;
    }
  }
  
  
  
  
  
  // Logo
  
  const logoUploaderRef = useRef();
  const [logoFile, setLogoFile] = useState(null);
  const [logoUploading, setLogoUploading] = useState(false);
  
  async function handleLogoUploaderChange(e) {
    if(logoUploading) {
      return;
    }
    setLogoUploading(true);
    try {
      setLogoFile(e.target.files[0]);
      var fr = new FileReader();
      fr.onload = function() {
        updateTpl({logo:fr.result});
        setLogoUploading(false);
      };
      fr.readAsDataURL(e.target.files[0]);
    } catch(error) {
      console.error(error);
      setLogoUploading(false);
      return;
    }
  }
  
  
  // Message
  
  const [textColor, setTextColor] = useState(tpl && tpl.color ? {hex:tpl.color} : {hex:"#ffffff"});
  
  function updateFontSize(size) {
    updateTpl({fontSize:Math.round(size*MAX_FONTSIZE)});
  }
  
  
  // Emit save.
  
  function save() {
    onSave(tpl, {background:bgFile, logo:logoFile});
  }
  
  
  
  // Render
  
  return (
    <div className="tagedit2">
    
    
      <div className="tagedit2-left">
        <div className="tagedit2-left-header">
          <Text block style={{flex:1}} bold large color={darkBlue}>{tag.name || tag.variant.title}</Text>
          {/*
          <Button onClick={() => onChangeType('image')} backgroundColor="#f76480">
            <svg width="24" height="24" viewBox="0 0 24 24" style={{fill:'white', marginRight:8}}>
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
            </svg>
            <Text white>Upload your print-ready design</Text>
          </Button>
          */}
        </div>
        <div className="tagedit2-left-body">
          <TagPreview 
            {...tag}
            template={tpl ? {...baseTpl, ...tpl} : null}
          />
          {/*<div 
            style={{
              overflow: 'hidden',
              width: size.width,
              height: size.height,
              borderRadius: shape === 'round' ? '50%' : 'none',
              backgroundColor: 'white',
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
              marginBottom: 40,
            }}
            dangerouslySetInnerHTML={{__html:html}}
          />
          <Text block style={{marginBottom:32}}>{tag.name || tag.variant.title}</Text>*/}
        </div>
      </div>
      
      
      
      <div className="tagedit2-right">
        {/*<div className="tagedit2-right-header">
        </div>*/}
        <div className="tagedit2-right-body">
        
        
          <Text block bold style={{marginBottom:16}}>Choose a Background</Text>
          
          <ColorPicker
            color={bgColor}
            onChange={color => setBgColor(color)}
            onChangeComplete={color => color && updateTpl({background:color.hex})}
            pointer={
              () => <div 
                style={{
                  width: 24,
                  height: 24,
                  transform: 'translate(-12px, -6px)',
                  borderRadius: 12,
                  backgroundColor: bgColor.hex,
                  boxShadow: "0 2px 2px rgba(0,0,0,0.3)",
                }}
              />
            }
          />
          {/*<div className="tagedit2-right-bgs">
            {["#000000", "#808080", "#e6e6e6", "#ffffff", "#253745", "#fc521f", "#f9af48", "#40b44f"].map(color => 
              <div
                key={color}
                className="tagedit2-right-bg"
                style={{background:color}}
                onClick={() => updateTpl({background:color})}
              />
            )}
          </div>*/}
          
          {/*
          <Text small block style={{padding:"16px 0 8px 0"}}>or choose CMYK</Text>
          <div>
            <Input value={bgC} placeholder="C" onChange={setBgC} style={{display:'inline-block', width:50, marginRight:8}} inputStyle={{boxShadow:'none'}}/>
            <Input value={bgM} placeholder="M" onChange={setBgM} style={{display:'inline-block', width:50, marginRight:8}} inputStyle={{boxShadow:'none'}}/>
            <Input value={bgY} placeholder="Y" onChange={setBgY} style={{display:'inline-block', width:50, marginRight:8}} inputStyle={{boxShadow:'none'}}/>
            <Input value={bgK} placeholder="K" onChange={setBgK} style={{display:'inline-block', width:50, marginRight:8}} inputStyle={{boxShadow:'none'}}/>
          </div>
          */}
          
          <Text small block style={{padding:"16px 0 8px 0"}}>or use background Image</Text>
          <div>
            <Button label={tpl && tpl.background.indexOf("url") > -1 ? "Replace Image" : "Upload Image"} backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)', marginRight:8}} onClick={() => setBGDialogOpen(true)}/>
            {tpl && tpl.background.indexOf("url") > -1 && 
              <Button label="Remove" backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)'}} onClick={() => updateTpl({background:"#ffffff"})}/>
            }
          </div>
          <input type="file" onChange={handleBgUploaderChange} style={{display:'none'}} ref={bgUploaderRef}/>
          
          
          
          
          <Text block bold style={{padding:"32px 0 16px 0"}}>Upload a Logo</Text>
          <Button label={tpl && tpl.logo ? "Replace Logo" : "Add Logo"} backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)', marginRight:8}} onClick={() => setLogoDialogOpen(true)}/>
          {tpl && tpl.logo && 
            <Button label="Remove" backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)'}} onClick={() => updateTpl({logo:""})}/>
          }
          <input type="file" onChange={handleLogoUploaderChange} style={{display:'none'}} ref={logoUploaderRef}/>
          
          <Text small block style={{padding:"16px 0 8px 0"}}>logo size</Text>
          <Slider
            value={tpl && tpl.logoWidth ? tpl.logoWidth / 100 : 0.5}
            onChange={v => updateTpl({logoWidth: Math.round(v*100)})}
          />
          
          
          
          
          <Text block bold style={{padding:"32px 0 16px 0"}}>Add a Message</Text>
          
          <Input 
            placeholder="Message" 
            outline
            value={tpl ? tpl.message : ""}
            onChange={message => updateTpl({message})}
          />
          
          
          <Text small block style={{padding:"16px 0 8px 0"}}>Color</Text>
          
          <ColorPicker
            color={textColor}
            onChange={color => setTextColor(color)}
            onChangeComplete={color => color && updateTpl({color:color.hex})}
            pointer={
              () => <div 
                style={{
                  width: 24,
                  height: 24,
                  transform: 'translate(-12px, -6px)',
                  borderRadius: 12,
                  backgroundColor: textColor.hex,
                  boxShadow: "0 2px 2px rgba(0,0,0,0.3)",
                }}
              />
            }
          />
          
          {/*
          <div className="tagedit2-right-colors">
            {["#000000", "#808080", "#e6e6e6", "#ffffff", "#253745", "#fc521f", "#f9af48", "#40b44f"].map(color => 
              <div
                key={color}
                className="tagedit2-right-color"
                style={{background:color}}
                onClick={() => updateTpl({color})}
              />
            )}
          </div>
          <Text small block style={{padding:"16px 0 8px 0"}}>or choose CMYK</Text>
          <div>
            <Input value={textC} placeholder="C" onChange={setTextC} style={{display:'inline-block', width:50, marginRight:8}} inputStyle={{boxShadow:'none'}}/>
            <Input value={textM} placeholder="M" onChange={setTextM} style={{display:'inline-block', width:50, marginRight:8}} inputStyle={{boxShadow:'none'}}/>
            <Input value={textY} placeholder="Y" onChange={setTextY} style={{display:'inline-block', width:50, marginRight:8}} inputStyle={{boxShadow:'none'}}/>
            <Input value={textK} placeholder="K" onChange={setTextK} style={{display:'inline-block', width:50, marginRight:8}} inputStyle={{boxShadow:'none'}}/>
          </div>
          */}
          <Text small block style={{padding:"16px 0 8px 0"}}>Font Size</Text>
        
          <Slider
            value={tpl && tpl.fontSize ? tpl.fontSize / MAX_FONTSIZE : 0.5}
            onChange={updateFontSize}
          />
        
        
        
        </div>
        <div className="tagedit2-save">
          <Button label="SAVE & CLOSE" small white onClick={save}/>
        </div>
      </div>
      
      <MediaDialog 
        open={isBGDialogOpen} 
        onRequestClose={() => setBGDialogOpen(false)} 
        media={media}
        onUpload={() => {
          setBGDialogOpen(false);
          bgUploaderRef.current.click();
        }}
        onSelect={url => {
          updateTpl({background:`url(${url})`});
          setBGDialogOpen(false);
        }}
      />
      <MediaDialog 
        open={isLogoDialogOpen} 
        onRequestClose={() => setLogoDialogOpen(false)} 
        media={media}
        onUpload={() => {
          setLogoDialogOpen(false);
          logoUploaderRef.current.click();
        }}
        onSelect={url => {
          updateTpl({logo:url});
          setLogoDialogOpen(false);
        }}
      />
    </div>
  );
}